import script from "./KeyDates.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyDates.vue?vue&type=script&setup=true&lang=js"

import "./KeyDates.vue?vue&type=style&index=0&id=a17d14e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a17d14e0"]])

export default __exports__